module.exports = __webpack_public_path__ + "img/tmf-icon-M-round.69d6e1f0.png";